<div class="w-100">
  <mwp-card-content-header [url]="apiUrl" />
  @if (!displayConfirmMember) {
  <div class="content-container">
    <div class="title">
      <mwp-text-translate text="MEMBER RESULTS" key="MEMBER RESULTS"/>
    </div>
    <div class="content">
      <div class="sub-title px-0">
        <mwp-text-translate text="Click the underlined name of the employee to proceed to their enrollment portal." key="memberLookupResultsInfo"/>
      </div>
      <mwp-member-members-grid [members]="members" (emitSelectedMember)="selectedMember($event)"/>
    </div>
  </div>
  }
  @if (displayConfirmMember) {
  <div>
    <mwp-member-confirm [member]="member" (emitBack)="back()" />
  </div>
  }
</div>